(function() {
    'use strict';

    angular
        .module('atheer.home', [
            'ui.carousel'
        ]);
})();
